import script from "./AirSterilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AirSterilePage.vue?vue&type=script&setup=true&lang=js"

import "./AirSterilePage.vue?vue&type=style&index=0&id=117da55b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117da55b"]])

export default __exports__